const WORKFLOW_TYPES = Object.freeze({
    PERSON: 'PERSON',
    BUSINESS: 'BUSINESS',
    WORKSPACE: 'WORKSPACE',
    ENROLLMENT: 'ENROLLMENT'
});

export default WORKFLOW_TYPES;